import BaseController from "./base_controller";

export default class extends BaseController {
  static targets = [ "siteGroupForm", "alarmFactor", "alarmFactorTrend", "alarmCount", "topAlarmActivity",
                     "advancedQuickActionsButton",
                     "aqaLinks"
                    
  ];

  connect() {

    this.loadAlarmFactor();
    this.loadAlarmFactorTrend();
    this.loadAlarmCount();
    this.loadTopAlarmActivity();
    //this.loadExcessiveOperatorActions();

    this.advancedQuickActionsButtonTarget.addEventListener("click", e =>
    {
      let isOpened = this.advancedQuickActionsButtonTarget.classList.contains("open");
      if(!isOpened)
      {
        this.advancedQuickActionsButtonTarget.classList.add("open");
        this.aqaLinksTarget.classList.remove("hidden");
      }
      else
      {
        this.advancedQuickActionsButtonTarget.classList.remove("open");
        this.aqaLinksTarget.classList.add("hidden");
      }
    })
  }

  changeSiteGroup(event) {
    this.siteGroupFormTarget.submit();
  }

  loadAlarmFactor() {
    this.fetchForTarget(window.App.prefixedUrl(`/dashboard/alarm-factor?${this.paramsString()}`), this.alarmFactorTarget);
  }

  loadAlarmFactorTrend() {
    this.fetchForTarget(window.App.prefixedUrl(`/dashboard/alarm-factor-trend?${this.paramsString()}`), this.alarmFactorTrendTarget);
  }

  loadAlarmCount() {
    this.fetchForTarget(window.App.prefixedUrl(`/dashboard/alarm-count?${this.paramsString()}`), this.alarmCountTarget);
  }

  loadTopAlarmActivity() {
    this.fetchForTarget(window.App.prefixedUrl(`/dashboard/top-alarm-activity?${this.paramsString()}`), this.topAlarmActivityTarget);
  }

  loadExcessiveOperatorActions() {
    this.fetchForTarget(window.App.prefixedUrl(`/dashboard/excessive-operator-actions?${this.paramsString()}`),
      this.excessiveOperatorActionsTarget);
  }

  paramsString() {
    return new URLSearchParams(window.location.search).toString();
  }
}